import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/invoice";

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function obtain(invoiceId) {
  return request({
    url: prefix + '/obtain/' + invoiceId,
    method: 'get',
  })
}

export function obtainByQrCode(qrcode) {
  return request({
    url: prefix + '/obtain/qrcode/' + qrcode,
    method: 'get',
  })
}

export function exportCsv(criteria) {
  return request({
    url: prefix + '/export/',
    method: 'post',
    data: criteria,
  })
}

export function exportLinesCsv(criteria) {
  return request({
    url: prefix + '/export/lines',
    method: 'post',
    data: criteria,
  })
}

// 获取发票及附件
export function getFiles(id) {
  return request({
    url: prefix + '/getFiles/' + id,
    method: 'get'
  })
}
